<template>
  <KPICard :title="'Points Spent'">
    <div class="row align-items-center">
      <div class="col">
        <h6 class="card-title text-uppercase text-muted mb-2">Points Spent</h6>
        <span class="h2 mb-0">{{ totalPointsSpent }}</span>
      </div>
      <div class="col-auto">
        <span class="h2 fe fe-heart text-muted mb-0"></span>
      </div>
    </div>
  </KPICard>
</template>

<script>
import KPICard from '@/components/Cards/KPICard'

export default {
  name: 'TotalPointsSpentCard',
  props: ['totalPointsSpent'],
  components: {
    KPICard
  }
}
</script>

<style scoped lang="scss"></style>
